import React, { Component } from 'react'
import { connect } from 'react-redux'
import BodyClassName from 'react-body-classname'
import { Link } from 'react-router-dom'

import { withRouter } from 'react-router'

import CONSTANTS from '../../constants'
import SearchArea from '../search-area/search-area'
import './header.css'
import logoAP from '../../images/AP/ap-logo-large.svg'
import logoMobileAP from '../../images/AP/ap-logo-mobile.svg'
import logoAC from '../../images/AC/ac-logo.png'
import logoACMobile from '../../images/AC/ac-logo-mobile.svg'
import logoDS from '../../images/DS/ds-logo.png'
import logoOV from '../../images/OV/ov-logo.png'

import {
  CurrentStepSetAction,
  dealerSetAction,
  bookingSetAction,
  setVeiculeInfos,
  setVeiculeKilo,
  setServices,
  setEditMode,
  selectedServices,
  setCommentServices,
  setPersonalInformations,
  setSelectedPremiumServicesToStore
} from '../../actions/action'

const mapStateToProps = state => state
const mapDispatchToProps = {
  CurrentStepSetAction,
  dealerSetAction,
  bookingSetAction,
  setVeiculeInfos,
  setVeiculeKilo,
  setServices,
  setEditMode,
  selectedServices,
  setCommentServices,
  setPersonalInformations,
  setSelectedPremiumServicesToStore
}

class PageHeader extends Component {
  constructor(props) {
    super(props)
    this.state = {
      stickyHeader: ''
    }
    this.headerDOM = null
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    // if you arrive to car-details page then forget sticky header .
    this.headerDOM = React.createRef()

    window.addEventListener('scroll', (event) => {
      if (this.headerDOM.current != null) {
        if (CONSTANTS.SITE_INFO.BRAND_CODE !== 'C' && window.scrollY > this.headerDOM.current.offsetHeight && this.props.store.step < 3) {
          this.setState({ stickyHeader: 'sticky-scroll' })
        }
        else if (CONSTANTS.SITE_INFO.BRAND_CODE === 'C' && window.scrollY > this.headerDOM.current.offsetHeight+400 && this.props.store.step < 3) {
          this.setState({ stickyHeader: 'sticky-scroll' })
        }
        else if (CONSTANTS.SITE_INFO.BRAND_CODE === 'C' && window.scrollY < this.headerDOM.current.offsetHeight+400 && this.props.store.step < 3) {
          this.setState({ stickyHeader: 'no-scroll' })
        }
        if (window.scrollY == 0) { this.setState({ stickyHeader: 'no-scroll' }) }
      }
    })
  }

  render() {
    function isHomePageWitoutMap() {
      return (window.siteConfig.ActivateHomepageMap == 0)
    }

    function refreshStore() {
      this.props.dealerSetAction({})
      this.props.bookingSetAction({})
      this.props.setVeiculeInfos({})
      this.props.setVeiculeKilo({})
      this.props.setServices([])
      this.props.selectedServices([])
      this.props.setCommentServices("");
      this.props.setSelectedPremiumServicesToStore([])
      this.props.setListPremiumServicesToStore([])
      this.props.setPersonalInformations({})
      this.props.CurrentStepSetAction(1);
      this.props.setEditMode(false)
    }

    function detectmob() {
      if (window.innerWidth <= 800) {
        return true
      } else {
        return false
      }
    }
    const bgPicture = (detectmob() ? window.siteConfig.MobileBackgroundImage : window.siteConfig.DesktopBackgroundImage)
    const logo = (window.siteConfig.currentBrand == 'P' ? logoAP : (window.siteConfig.currentBrand == 'C' ? logoAC : (window.siteConfig.currentBrand == 'D' ? logoDS : logoOV)))
    const logoMobile = (window.siteConfig.currentBrand == 'P' ? logoMobileAP : (window.siteConfig.currentBrand == 'C' ? logoACMobile : (window.siteConfig.currentBrand == 'D' ? logoDS : logoOV)))
    const containerClass = (window.siteConfig.currentBrand == 'V' || window.siteConfig.currentBrand == 'D') ? "container-full-width" : "container-medium-content";
    return (
      <>
        {this.props.store.step > 2 && <BodyClassName className='withSummary' />}
        {this.props.store.isEditMode && <BodyClassName className='editMode' />}

        <header
          ref={this.headerDOM}
          style={{ backgroundImage: (isHomePageWitoutMap() && this.props.store.step == 1 ? `url(${bgPicture})` : false) }}
          className={this.props.store.step > 1 ? this.state.stickyHeader : ''}
        >
          <div className={`container ${containerClass}`}>
            <div className='header-area'>
              <div className='mark-logo'>
                <Link to={CONSTANTS.SITE_ROUTS.HOMEPAGE} onClick={
                  (e) => refreshStore()}>
                  {detectmob()
                    ? <img src={logoMobile} title={CONSTANTS.SITE_INFO.BRAND_NAME} alt={`${CONSTANTS.SITE_INFO.BRAND_NAME} ${CONSTANTS.LABELS.dealer_locator_title1}`} />
                    : <img src={logo} title={CONSTANTS.SITE_INFO.BRAND_NAME} alt={`${CONSTANTS.SITE_INFO.BRAND_NAME} ${CONSTANTS.LABELS.dealer_locator_title1}`} />
                  }
                </Link>
              </div>
              <div className='mark-headline'>
                <h1 className='page-title'>
                  <span tabIndex="0" className='first-ligne'>
                    {CONSTANTS.SITE_INFO.BRAND_CODE === 'C' && <strong className='mark-name'> Citroën <span className='country-name'>{CONSTANTS.LABELS.common_v2_logo_aconly}</span></strong>}


                    <span dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.dealer_locator_title1) }}  className='title-prdv'></span>
                  </span>



                   {CONSTANTS.SITE_INFO.BRAND_CODE !== 'C' && <span className='seconde-ligne'>
                    <p tabIndex="0" className='paragraphe' dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.dealer_locator_title2) }}></p>
                  </span>}
                </h1>
              </div>
            </div>
            <SearchArea />
          </div>
        </header>
      </>
    )
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PageHeader))
